import React, { Component } from 'react';
import { Container, Modal, Image } from 'semantic-ui-react';
import { LocaleContext } from '../locale-context';
import en from '../locales/en.json';
import ro from '../locales/ro.json';
const uuidv1 = require('uuid/v1');

const langs = {
    en,
    ro
};

const styles = {
    basic: {
        borderRadius: '3px',
        boxShadow: '0 1.5rem 4rem rgba(0, 0, 0, 0.2)',
        textAlign: 'left',
        backgroundSize: '100%'
    }
};

const isMobile = width => width < 900;

class ServiceComponent extends Component {
    state = {
        windowWidth: 0
    };

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => this.setState({ windowWidth: window.innerWidth });

    render() {
        const divStyle = {
            desktop: {
                backgroundImage: `linear-gradient(105deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 50%, transparent 50%), url(${
                    this.props.service['imageBase64']
                })`,
                backgroundSize: '100%'
            },
            mobile: {
                backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%), url(${
                    this.props.service['imageBase64']
                })`,
                backgroundSize: 'cover'
            }
        };

        const { windowWidth } = this.state;
        const style = Object.assign(
            {},
            styles.basic,
            isMobile(windowWidth) ? divStyle.mobile : divStyle.desktop
        );

        return (
            <div style={style}>
                <div className="service-card-details">
                    <h2 className="service-card-heading">
                        {this.props.service['title']}
                    </h2>
                    <h1 className="heading-tertiary">
                        {this.props.service['subtitle']}
                    </h1>
                    <ul>
                        {this.props.service['techniques'].map(technique => (
                            <li key={uuidv1()}>{technique}</li>
                        ))}
                    </ul>
                    <span>{this.props.service['closingLine']}</span>
                    <a href="/contact" className="btn btn-green ">
                        {this.props.language === 'en'
                            ? 'Request offer'
                            : 'Solicita oferta'}{' '}
                        &rarr;
                    </a>
                </div>
            </div>
        );
    }
}

const ServiceModalComponent = ({ isOpen, closeEmailModal, language }) => (
    <Modal
        dimmer="blurring"
        style={inlineStyle.modal}
        open={isOpen}
        onClose={closeEmailModal}
    >
        <Modal.Header>
            {language === 'en' ? 'Send an email' : 'Trimite un email'}
        </Modal.Header>
        <Modal.Content>
            <p>To be completed - email service</p>
        </Modal.Content>
    </Modal>
);

const ServiceList = ({ service, showEmailModal, language }) => (
    <Container fluid className="service-list">
        <ServiceComponent
            service={service}
            showEmailModal={showEmailModal}
            language={language}
        />
    </Container>
);

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openEmailModal: false
        };
    }

    showEmailModal = e => {
        e.preventDefault();
        this.setState({ openEmailModal: true });
    };

    closeEmailModal = () => this.setState({ openEmailModal: false });

    render() {
        const { language } = this.props;
        const translations = {
            en: {
                header1: 'Services',
                header2: 'List of offerings'
            },
            ro: {
                header1: 'Servicii',
                header2: 'Lista cu oferte'
            }
        };
        const labels = translations[language];

        return (
            <React.Fragment>
                <section className="cover cover-middle">
                    <div className="text-box">
                        <h1 className="heading-primary">
                            <span className="heading-primary-main">
                                {labels.header1}
                            </span>
                            <span className="heading-primary-sub">
                                {labels.header2}
                            </span>
                        </h1>
                    </div>
                </section>

                {langs[language]['services'].map(service => (
                    <ServiceList
                        language={language}
                        service={service}
                        showEmailModal={this.showEmailModal}
                        key={uuidv1()}
                    />
                ))}

                <ServiceModalComponent
                    isOpen={this.state.openEmailModal}
                    closeEmailModal={this.closeEmailModal}
                    language={language}
                />
            </React.Fragment>
        );
    }
}

const LocaleConsumer = () => (
    <LocaleContext.Consumer>
        {value => <Services language={value} />}
    </LocaleContext.Consumer>
);

const inlineStyle = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};

export default LocaleConsumer;



// WEBPACK FOOTER //
// ./src/components/Services.js